import { Form, Row } from 'antd';
import React, { useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import DatePickerComponent from 'components/atoms/DatePickerComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import FormWrapper from 'components/molecules/FormWrapper';

import { useDateLimit } from 'hooks/statniSprava/useDateLimit';
import { useFormBasics } from 'hooks/statniSprava/useFormBasics';

import numberValidation from 'utils/validations/numberValidation';
import pismenaCislaValidation from 'utils/validations/pismenaCislaValidation';

import AlertComponent from './AlertComponent';
import OdeslaniPozadavkuRows from './odeslaniPozadavkuRows';

interface IF5 {}

const F5: React.FC<IF5> = () => {
    const [form] = Form.useForm();
    const [, dateLoading, commonDisabledDate] = useDateLimit();
    const [nepovinneValErr, setNepovinneValErr] = useState<boolean>(false);
    const [
        errMsg,
        currentStep,
        idSluzby,
        upozorneni,
        loading,
        odeslaniResp,
        setErrMsg,
        prev,
        onFormSubmit,
        showPxKlicLoadingMsg
    ] = useFormBasics();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onFinish = (fieldsValue: any) => {
        if (fieldsValue.rliv || fieldsValue.idve || fieldsValue.iddl) {
            const dataToSend = {
                ...fieldsValue,
                dtvp: fieldsValue.dtvp.format('YYYY-MM-DD')
            };
            onFormSubmit(dataToSend);
        } else {
            setNepovinneValErr(true);
        }
    };

    return (
        <LoadingWrapper loading={loading} loadingText={showPxKlicLoadingMsg ? 'LOADING_PXKLIC' : 'NACITANI'}>
            <Title level={4} text="DUVERNE_INFO_TITLE_F5" />{' '}
            {errMsg ? (
                <>
                    <Paragraph text={errMsg} />
                    <Row>
                        <ButtonComponent
                            type="default"
                            buttontext="ZPET"
                            onClick={() => setErrMsg('')}
                            id="f5ZpetBtn"
                        />
                    </Row>
                </>
            ) : (
                <>
                    {currentStep !== 2 ? (
                        <FormWrapper onFinish={onFinish} outForm={form}>
                            <LoadingWrapper loading={dateLoading}>
                                <DatePickerComponent
                                    name="dtvp"
                                    label="DUVERNE_INFO_POZADOVANY_DEN"
                                    disabled={currentStep > 0}
                                    disabledDate={current => commonDisabledDate(current)}
                                />
                            </LoadingWrapper>
                            <InputComponent
                                label="ME_POZADAVKY_CISLO_ZMLUVY"
                                name="rliv"
                                type="text"
                                maxLength={12}
                                disabled={currentStep > 0}
                                hide={currentStep === 1 && !form.getFieldValue('rliv')}
                                extramessage={nepovinneValErr ? 'DUVERNE_INFO_NEPOVINNE_ERR' : ''}
                                rules={numberValidation()}
                                notRequired={true}
                                onChange={() => setNepovinneValErr(false)}
                            />
                            <InputComponent
                                label="ME_POZADAVKY_IDIC_VERITEL"
                                name="idve"
                                type="text"
                                maxLength={50}
                                rules={pismenaCislaValidation()}
                                notRequired={true}
                                disabled={currentStep > 0}
                                hide={currentStep === 1 && !form.getFieldValue('idve')}
                                extramessage={nepovinneValErr ? 'DUVERNE_INFO_NEPOVINNE_ERR' : ''}
                                onChange={() => setNepovinneValErr(false)}
                            />
                            <InputComponent
                                label="ME_POZADAVKY_IDIC_DLUZNIK"
                                name="iddl"
                                type="text"
                                maxLength={50}
                                rules={pismenaCislaValidation()}
                                notRequired={true}
                                disabled={currentStep > 0}
                                hide={currentStep === 1 && !form.getFieldValue('iddl')}
                                extramessage={nepovinneValErr ? 'DUVERNE_INFO_NEPOVINNE_ERR' : ''}
                                onChange={() => setNepovinneValErr(false)}
                            />
                            {currentStep !== 0 && upozorneni && (
                                <AlertComponent upozorneni={upozorneni} type={currentStep === 1 ? 'error' : 'info'} />
                            )}
                            <Row className="button-row">
                                {currentStep === 1 && (
                                    <ButtonComponent
                                        buttontext="ZPET"
                                        onClick={() => prev()}
                                        type="default"
                                        id="f5ZpetAltBtn"
                                    />
                                )}
                                <ButtonComponent buttontext="ODESLAT" onClick={() => form.submit()} id="f5OdeslatBtn" />
                            </Row>
                        </FormWrapper>
                    ) : (
                        <>
                            <OdeslaniPozadavkuRows idSluzby={idSluzby} datum={odeslaniResp?.datum} />
                            {upozorneni && <AlertComponent upozorneni={upozorneni} type={'info'} />}
                        </>
                    )}{' '}
                </>
            )}
        </LoadingWrapper>
    );
};

export default F5;
